const axios = require("axios");
const swal = require("sweetalert2");

const bundleStore = {
  state: {
    product_id: null,
    product_locale_id: null,
    product_meta: [],
    product: null,
    product_label: null,
    vendors: [],
    has_discount_check_box: 0,
    has_addon: 0,
    has_renewal: 0,
    is_gated: 0,
    is_disabled: 0,
    is_upgrade: 0,
    is_segment: 0,
    is_standalone: 0,
    content_assets: [],
    discounts: [],
    addons: [],
    renewals: [],
    gates: [],
    cycles: "",
    item_name: null,
    product_addon: null,
    product_discount: null,
    product_renewal: null,
    loading_cycles: false,
    gated_id: null,
    gated_code: null,
    gated_msg: "",
    loading_submit: false,
    product_details_template: null,
  },
  mutations: {
    SET_PRODUCT_ID(state, prodId) {
      // eslint-disable-next-line no-param-reassign
      state.product_id = prodId;
    },
    SET_PRODUCT_LABEL(state, label) {
      // eslint-disable-next-line no-param-reassign
      state.product_label = label;
    },
    SET_PRODUCT_LOCALE_ID(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.product_locale_id = val;
    },
    SET_PRODUCT(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.product = obj;
    },
    PUSH_PRODUCT_META_DATA(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.product_meta.push(obj);
    },
    SET_VENDORS(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.vendors = obj;
    },
    SET_HAS_DISCOUNT_CHECK_BOX(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.has_discount_check_box = status;
    },
    SET_HAS_ADDON(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.has_addon = status;
    },
    SET_HAS_RENEWAL(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.has_renewal = status;
    },
    IS_GATED_CHECKBOX(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.is_gated = status;
    },
    IS_DISABLED_CHECKBOX(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.is_disabled = status;
    },
    IS_UPGRADE_CHECKBOX(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.is_upgrade = status;
    },
    IS_SEGMENT_CHECKBOX(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.is_segment = status;
    },
    IS_STANDALONE_CHECKBOX(state, status) {
      // eslint-disable-next-line no-param-reassign
      state.is_standalone = status;
    },
    INIT_BUNDLE_ASSETS(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.content_assets = obj;
    },
    ADD_BUNDLE_ASSET(state, obj) {
      state.content_assets.push(obj);
    },
    SET_CONTENT_SOURCE_INPUT(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.content_assets[data.index].content_source = data.type;
    },
    SET_VIDEO_INPUT(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.content_assets[data.index].video = data.value;
    },
    SET_BUNDLE_IMAGE(state, data) {
      // eslint-disable-next-line no-param-reassign
      state.content_assets[data.index].image = data.content_image;
    },
    SET_GATE_ID(state, id) {
      // eslint-disable-next-line no-param-reassign
      state.gated_id = id;
    },
    SET_GATE_CODE(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.gated_code = val;
    },
    SET_GATE_MSG(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.gated_msg = val;
    },
    SET_DISCOUNTS(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.discounts = obj;
    },
    SET_ADDONS(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.addons = obj;
    },
    SET_RENEWALS(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.renewals = obj;
    },
    SET_GATES(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.gates = obj;
    },
    SET_CYCLES(state, obj) {
      // eslint-disable-next-line no-param-reassign
      state.cycles = obj;
    },
    SET_ITEM_NAME(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.item_name = val;
    },
    SET_PRODUCT_ADDON(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.product_addon = val;
    },
    SET_PRODUCT_DISCOUNT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.product_discount = val;
    },
    SET_PRODUCT_RENEWAL(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.product_renewal = val;
    },
    SET_LOADING_CYCLES(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.loading_cycles = val;
    },
    SET_LOADING_SUBMIT(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.loading_submit = val;
    },
    DELETE_CONTENT_ITEM(state, index) {
      state.content_assets.splice(index, 1);
    },
    SET_PRODUCT_TEMPLATE(state, val) {
      // eslint-disable-next-line no-param-reassign
      state.product_details_template = val;
    },
    DELETE_CONTENT_TYPE(state, index) {
      state.content_assets.splice(index, 1);
    },
    DELETE_CONTENT_SRC(state, index) {
      state.content_assets.splice(index, 1);
    },
    DELETE_CONTENT_IMG(state, index) {
      state.content_assets.splice(index, 1);
    },
  },
  actions: {
    setProductId({ commit }, pathname) {
      const uri = pathname.split("/");
      const productId = uri[2] ? uri[2] : null;

      return new Promise((resolve) => {
        commit("SET_PRODUCT_ID", productId);
        resolve(productId);
      });
    },
    setProductAddon({ commit }, addonId) {
      commit("SET_PRODUCT_ADDON", addonId);
    },
    setDiscount({ commit }, valId) {
      commit("SET_PRODUCT_DISCOUNT", valId);
    },
    setRenewal({ commit }, valId) {
      commit("SET_PRODUCT_RENEWAL", valId);
    },
    // eslint-disable-next-line no-unused-vars
    getProductMeta({ commit, dispatch }, productId) {
      const metaLabels = ["sku_prefix", "duration", "terms"];
      metaLabels.forEach((metaLabel) => {
        dispatch("getMeta", { product_id: productId, key: metaLabel });
      });
    },
    pushMetaData({ commit }, obj) {
      if (obj.data.meta) {
        commit("PUSH_PRODUCT_META_DATA", obj.data.meta);
      }
    },
    // eslint-disable-next-line no-unused-vars
    setCheckBoxStatus({ commit, dispatch }, data) {
      let { status } = data;
      const { type } = data;
      status = parseInt(status, 10) === 0 ? 1 : 0;

      switch (type) {
        case "has_discount":
          commit("SET_HAS_DISCOUNT_CHECK_BOX", status);
          if (status === 0) commit("SET_PRODUCT_DISCOUNT", null);
          break;
        case "has_addon":
          commit("SET_HAS_ADDON", status);
          if (status === 0) commit("SET_PRODUCT_ADDON", null);
          break;
        case "has_renewal":
          commit("SET_HAS_RENEWAL", status);
          if (status === 0) commit("SET_PRODUCT_RENEWAL", null);
          break;
        case "is_gated":
          commit("IS_GATED_CHECKBOX", status);
          break;
        case "is_disabled":
          commit("IS_DISABLED_CHECKBOX", status);
          break;
        case "is_upgrade":
          commit("IS_UPGRADE_CHECKBOX", status);
          break;
        case "is_segment":
          commit("IS_SEGMENT_CHECKBOX", status);
          break;
        case "is_standalone":
          commit("IS_STANDALONE_CHECKBOX", status);
          break;
        default:
      }
    },
    setInitialBundleAssets({ commit }) {
      commit("INIT_BUNDLE_ASSETS", [
        { content_source: "image", image: null, video: null },
      ]);
    },
    addBundleAsset({ commit }) {
      commit("ADD_BUNDLE_ASSET", {
        content_source: "image",
        image: null,
        video: null,
      });
    },
    setContentSourceInput({ commit }, data) {
      commit("SET_CONTENT_SOURCE_INPUT", data);
    },
    setVideoInput({ commit }, data) {
      commit("SET_VIDEO_INPUT", data);
    },
    setBundleImage({ commit }, data) {
      commit("SET_BUNDLE_IMAGE", data);
    },
    // eslint-disable-next-line no-unused-vars
    showErrorAlert({ commit }, error) {
      if (error.response) {
        swal.fire({
          type: "error",
          title: "Error",
          html: `<h5>${error.response.data.message}</h5><br/>`,
          showConfirmButton: true,
        });
      }
      // eslint-disable-next-line no-console
      console.error(error.response);
    },
    seGateSelect({ commit }, val) {
      commit("SET_GATE_ID", val);
    },
    seGateCode({ commit }, val) {
      commit("SET_GATE_CODE", val);
    },
    seGateMsg({ commit }, val) {
      commit("SET_GATE_MSG", val);
    },
    handleDeleteContentItem({ commit }, index) {
      commit("DELETE_CONTENT_ITEM", index);
    },
    setProductLabel({ commit }, label) {
      commit("SET_PRODUCT_LABEL", label);
    },
    triggerNameAlert() {
      swal.fire({
        type: "error",
        title: "Error",
        html: "<h5> Please select different Bundle Slug. </h5><br/>",
        showConfirmButton: true,
      });
    },
    async getDiscounts({ commit }, localeId) {
      try {
        const response = await axios.get(`/get-discounts/${localeId}`);
        commit("SET_DISCOUNTS", response.data.discounts);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },
    async getAddons({ commit }, localeId) {
      try {
        const response = await axios.get(`/get-addons/${localeId}`);
        commit("SET_ADDONS", response.data.addons);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },
    async getGates({ commit }, localeId) {
      try {
        const response = await axios.get(`/get-gates/${localeId}`);
        commit("SET_GATES", response.data.gates);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },
    async getCycles({ commit }, data) {
      try {
        commit("SET_LOADING_CYCLES", true);
        const response = await axios.post(
          `/products/${data.product_id}/createBundle/estimateCycles`,
          data
        );
        if (response.data.result) {
          commit("SET_CYCLES", response.data.data);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }

      commit("SET_LOADING_CYCLES", false);
    },
    async getRenewals({ commit }, localeId) {
      try {
        const response = await axios.get(`/get-renewals/${localeId}`);
        commit("SET_RENEWALS", response.data.renewals);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },
    // eslint-disable-next-line no-unused-vars
    async getMeta({ commit, dispatch }, data) {
      try {
        const response = await axios.get(
          `/get-meta/${data.product_id}/${data.key}`
        );
        dispatch("pushMetaData", response);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },

    async getProductInfo({ commit }, productId) {
      try {
        const response = await axios.get(`/get-product-by-id/${productId}`);

        return new Promise((resolve) => {
          commit("SET_PRODUCT", response.data);
          commit("SET_PRODUCT_LABEL", response.data.label);
          commit("SET_PRODUCT_LOCALE_ID", response.data.locale_id);
          resolve(response.data.locale_id);
        });
      } catch (error) {
        return new Promise(() => {
          // eslint-disable-next-line no-console
          console.error(error.response);
        });
      }
    },

    async getVendors({ commit }, localeId) {
      try {
        const response = await axios.get(`/get-all-vendors/${localeId}`);
        commit("SET_VENDORS", response.data.vendors);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },
    async getItemName({ commit }, itemName) {
      try {
        const response = await axios.get(`/get-item-name/${itemName}`);
        if (response.data.name) {
          commit("SET_ITEM_NAME", true);
        } else {
          commit("SET_ITEM_NAME", false);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },
    async submitAddNewBundleForm({ commit, state, dispatch }, fields) {
      commit("SET_LOADING_SUBMIT", true);

      try {
        const response = await axios({
          url: `/products/${state.product_id}/createBundle`,
          method: "post",
          data: { allFields: fields, image: fields.content_img },
          transformRequest(data) {
            const formData = new FormData();
            formData.append("label", data.allFields.label);
            formData.append("sku", data.allFields.sku);
            formData.append("name", data.allFields.name);
            formData.append("vendor", data.allFields.vendor);
            formData.append("description", data.allFields.description);
            formData.append(
              "short_description",
              data.allFields.short_description
            );
            formData.append("display_body", data.allFields.display_body);
            formData.append("description", data.allFields.description);
            formData.append(
              "short_description",
              data.allFields.short_description
            );
            formData.append("display_body", data.allFields.display_body);
            formData.append("product_terms", data.allFields.product_terms);
            formData.append("sort_order", data.allFields.sort_order);
            formData.append("key_words", data.allFields.key_words);
            formData.append("disclaimer", data.allFields.disclaimer);
            formData.append(
              "cycle_price_disclaimer",
              data.allFields.cycle_price_disclaimer
            );
            formData.append("has_discount", data.allFields.has_discount);
            formData.append(
              "product_discount",
              data.allFields.product_discount
            );
            formData.append("has_addon", data.allFields.has_addon);
            formData.append("product_addons", data.allFields.product_addons);
            formData.append("has_renewal", data.allFields.has_renewal);
            formData.append(
              "product_renewals",
              data.allFields.product_renewals
            );
            formData.append("gated_id", data.allFields.gated_id);
            formData.append("gated_code", data.allFields.gated_code);
            formData.append("gated_msg", data.allFields.gated_msg);
            formData.append(
              "content_type",
              JSON.stringify(data.allFields.content_type)
            );
            formData.append(
              "content_src",
              JSON.stringify(data.allFields.content_src)
            );
            formData.append("is_gated", data.allFields.is_gated);
            formData.append("is_disabled", data.allFields.is_disabled);
            formData.append("is_upgrade", data.allFields.is_upgrade);
            formData.append("is_segment", data.allFields.is_segment);
            formData.append("is_standalone", data.allFields.is_standalone);
            fields.content_img.forEach((content, i) => {
              formData.append(`content_img_${i}`, content);
            });
            return formData;
          },
        });

        if (response.status === 200) {
          swal.fire({
            type: "success",
            title: "Success",
            html: "<h5>New product was added.</h5><br/>",
            showConfirmButton: false,
          });
          window.location.href = "/products";
        }
      } catch (error) {
        dispatch("showErrorAlert", error);
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
      commit("SET_LOADING_SUBMIT", false);
    },

    async setProductDetailsTemplate({ commit }) {
      try {
        const response = await axios.get("/get-product-details-template");

        commit("SET_PRODUCT_TEMPLATE", response.data.template);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error.response);
      }
    },
  },

  getters: {
    product_meta_sku(state) {
      const response = state.product_meta.filter((item) =>
        item.item_meta === "sku_prefix" ? item : ""
      );
      return response[0] ? response[0].item_value : "";
    },

    product_meta_duration(state) {
      const response = state.product_meta.filter((item) =>
        item.item_meta === "duration" ? item : ""
      );
      return response[0] ? response[0].item_value : "";
    },

    product_meta_terms(state) {
      const response = state.product_meta.filter((item) =>
        item.item_meta === "terms" ? item : ""
      );
      return response[0] ? response[0].item_value : "";
    },

    get_content_image(state) {
      const images = state.content_assets;
      const imagesFiltered = [];
      if (images.length > 0) {
        images.forEach((content) => {
          if (content.image) {
            imagesFiltered.push(content.image);
          }
        });
      }
      return imagesFiltered;
    },

    get_content_src(state) {
      const contents = state.content_assets;
      const contentSrc = [];
      contents.forEach((content) => {
        contentSrc.push(content.video);
      });
      return contentSrc;
    },

    get_content_type(state) {
      const contents = state.content_assets;
      const contentType = [];
      contents.forEach((content) => {
        contentType.push(content.content_source);
      });
      return contentType;
    },
  },
};

export default bundleStore;
